// extracted by mini-css-extract-plugin
module.exports =  {"root":"dYNANVmovQbaxaTXdKVj","label":"zxF7j71MPyqnYohOOX4w"};